import React from 'react';

export const Tillitsverv = () => {
  return (
    <>
      Tillitsverv page
    </>
  )
}